import NotFound from '../NotFound.vue';

export default [
  {
    path: '/:catchAll(.*)',
    name: 'catch-all',
    component: NotFound,
  },
];
